import Flickity from 'flickity-imagesloaded';
import _debounce from 'lodash/debounce';
import {
	getBreakpoint,
	getRTL,
	checkTouchSupport,
	horizontalResizeEvent,
	getIndexedHashProperty,
} from './_utils';
import { a11yHideSlide, a11yShowSlide } from './carousel';

const flickityObjects = {
	cards: [],
	experiences: [],
};

const isTouch = checkTouchSupport();
const rtl = getRTL();
let indexedHashProperty = getIndexedHashProperty();

function getOptions(type) {
	const bp = getBreakpoint();
	const mobile = bp === 'small';

	switch (type) {
		case 'cards':
			return {
				cellAlign: 'left',
				pageDots: false,
				contain: !mobile,
				groupCells: !mobile,
				rightToLeft: rtl,
				prevNextButtons: !isTouch,
				imagesLoaded: true,
			};
		case 'experiences':
			return {
				cellAlign: 'left',
				pageDots: false,
				watchCSS: true,
				prevNextButtons: false,
				rightToLeft: rtl,
				imagesLoaded: true,
			};
		case 'textMobile':
			return {
				cellAlign: 'left',
				prevNextButtons: false,
				rightToLeft: rtl,
				imagesLoaded: true,
			};
		default:
			return {};
	}
}

function fixCardsMinHeight(container, action = 'off') {
	const minHeight = action === 'on' ? '100%' : '';
	$(container).find('.flickity-equal-height').css('min-height', minHeight);
}

export default function init() {
	const getCardDetail = card => {
		const imgSrc = card.find('img').attr('src');
		const detail =
			card.find('.Heading-title').text().trim() ||
			card.find('img').attr('alt') ||
			(imgSrc ? imgSrc.split('/').pop() : '');
		return detail;
	};

	$('.cardpanel-carousel').each((i, element) => {
		const carousel = $(element);
		const trackInteractions = !!carousel.data('track-interactions');
		const carouselName =
			carousel
				.parents('.CardCarousel-parent')
				.prev('.container')
				.find('.CardCarousel-heading')
				.text()
				.trim() || 'Card Carousel';

		const flickity = new Flickity(element, getOptions('cards'));

		flickityObjects.cards.push({ flickity, element });

		fixCardsMinHeight(element, 'on');
		if (trackInteractions) {
			carousel.find('.CardCarousel-item').each((i, cardElem) => {
				const cardItem = $(cardElem);
				cardItem.find('a.CTA').click(function () {
					window.FS.Tealium.trackInteraction(
						'card carousel',
						carouselName + ' details click',
						getCardDetail(cardItem),
						$(this)
					);
				});
			});

			let hasSettled = false;

			flickity.on('select', () => {
				if (hasSettled) {
					const detailsArray = [];
					carousel.find('.CardCarousel-item.is-selected').each((i, cardElem) => {
						detailsArray.push(getCardDetail($(cardElem)));
					});
					window.FS.Tealium.trackInteraction(
						'card carousel',
						carouselName + ' click',
						detailsArray.join(',')
					);
				}
			});

			flickity.on('settle', () => {
				hasSettled = true;
			});
		}

		flickity.on('settle', () => {
			// Hide cells from keyboard users and screen readers
			const cells = flickity.getCellElements();
			cells.forEach(a11yHideSlide);
			if (flickity.selectedElements) {
				flickity.selectedElements.forEach(a11yShowSlide);
			}
		});
	});

	$('.experiences-carousel').each((i, element) => {
		let activeIndex = 0;
		if (indexedHashProperty) {
			const $scrollToElements = $(`#${indexedHashProperty.id}`);
			if ($scrollToElements.length) {
				// Check if the scroll to element is a part of current carousel
				if (
					$(element)
						.parents('.Experiences-carouselcontainer')
						.siblings(`#${indexedHashProperty.id}`).length
				) {
					activeIndex = indexedHashProperty.index - 1;
				}
			}
		}

		new Flickity(element, { ...getOptions('experiences'), initialIndex: activeIndex });
	});
	$('.TextMobileCarousel-Cardpanel-carousel').each((i, element) => {
		const carousel = $(element);
		const trackInteractions = !!carousel.data('track-interactions');
		const carouselName =
			carousel
				.parents('.TextMobileCarousel-parent')
				.prev('.container')
				.find('.TextMobileCarousel-heading')
				.text()
				.trim() || 'Text Mobile Carousel';

		const flickity = new Flickity(element, getOptions('textMobile'));

		flickityObjects.cards.push({ flickity, element });

		fixCardsMinHeight(element, 'on');

		if (trackInteractions) {
			carousel.find('.TextMobileCarousel-item').each((i, cardElem) => {
				const cardItem = $(cardElem);
				cardItem.find('a.CTA').click(function () {
					window.FS.Tealium.trackInteraction(
						'card carousel',
						carouselName + ' details click',
						getCardDetail(cardItem),
						$(this)
					);
				});
			});

			let hasSettled = false;

			flickity.on('select', () => {
				if (hasSettled) {
					const detailsArray = [];
					carousel.find('.TextMobileCarousel-item.is-selected').each((i, cardElem) => {
						detailsArray.push(getCardDetail($(cardElem)));
					});
					window.FS.Tealium.trackInteraction(
						'card carousel',
						carouselName + ' click',
						detailsArray.join(',')
					);
				}
			});

			flickity.on('settle', () => {
				hasSettled = true;
			});
		}
	});

	$(window).on(horizontalResizeEvent, _debounce(update, 100));
	window.addEventListener('carousel.contentChanged', _debounce(update, 100));
}

function update() {
	Object.keys(flickityObjects).forEach(key => {
		flickityObjects[key].forEach(({ flickity, element }, index) => {
			flickity.destroy();
			fixCardsMinHeight(element, 'off');
			flickityObjects[key][index] = {
				flickity: new Flickity(element, getOptions(key)),
				element,
			};
			fixCardsMinHeight(element, 'on');
		});
	});
}
